import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment.test';

@Injectable()
export class ChatMensajesService {
  private resourceUrl = environment.API_URL + '/chat-mensajes';

  constructor(private http: HttpClient) {}

  save(params: any): Observable<any> {
    return this.http.post(this.resourceUrl, params, { observe: 'response' });
  }

  byChat(chatId: number): Observable<any> {
    return this.http.get(`${this.resourceUrl}/by-chat/${chatId}`, {
      observe: 'response',
    });
  }
}
